import React, {FC} from "react"

import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"
import {H1} from "@irati/ui/src/Typography"

import styled from "styled-components"
import Tabs from "@irati/ui/src/Tabs"
import theme from "@irati/ui/src/global/theme"
import history from "@irati/utils/history"
import PropTypes from "prop-types"
import {RouteComponentProps} from "react-router"
import {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import AccountRecognition from "./Recognition"
import AccountTrophies from "./Trophies"
import AccountRewards from "./Rewards"

const MobileWrapper = styled.div`
  ${theme.mediaQueries.minWidthMedia.tablet`
      display: none;
  `}
`

const DesktopWrapper = styled.div`
  ${theme.mediaQueries.maxWidthMedia.tablet`
      display: none;
  `}
`

const MY_RECOGNITION = "my-recognition"
const MY_VOTES = "my-votes"
const MY_REWARDS = "my-rewards"
const MY_TROPHIES = "my-trophies"

interface Props extends InjectIntl, WithAuth, RouteComponentProps<{recognitionType: string}> {
}

const Account: FC<Props> = ({match, formatMessage}, context) => {
  const isRewardDisabled = authentication.apps("recognition.recognition.rewardDisabled")

  let tabs = [
    {
      title: formatMessage({id: "recognition.account.recognition.tabs.recognition"}),
      key: MY_RECOGNITION,
      component: <AccountRecognition />
    },
    {
      title: formatMessage({id: "recognition.account.recognition.tabs.votes"}),
      key: MY_VOTES,
      component: <AccountRecognition showVotes />
    },
    {
      title: formatMessage({id: "recognition.account.recognition.tabs.trophies"}),
      key: MY_TROPHIES,
      component: <AccountTrophies />
    }
  ]

  if (!isRewardDisabled) {
    tabs = [{
      title: formatMessage({id: "recognition.account.recognition.tabs.rewards"}),
      key: MY_REWARDS,
      component: <AccountRewards />},
    ...tabs
    ]
  }

  const getActiveKey = () => {
    const rType = match.params.recognitionType

    switch (rType) {
      case MY_REWARDS:
        return MY_REWARDS
      case MY_TROPHIES:
        return MY_TROPHIES
      case MY_VOTES:
        return MY_VOTES
      case MY_RECOGNITION:
        return MY_RECOGNITION
      default:
        if (isRewardDisabled) {
          return MY_RECOGNITION
        } else {
          return MY_REWARDS
        }
    }
  }

  return (
    <>
      <H1 marginTop={5} marginBottom={5}>
        <FormattedMessage id="recognition.account.recognition.tabs.title" />
      </H1>
      <MobileWrapper>
        <Tabs
          onSelect={(value) => {
            history.push(`/account/${value}`, context)
          }}
          fullWidth
          activeKey={getActiveKey()}
          id="myRecognition"
          tabs={tabs} />
      </MobileWrapper>
      <DesktopWrapper>
        <Tabs
          onSelect={(value) => {
            history.push(`/account/${value}`, context)
          }}
          activeKey={getActiveKey()}
          id="myRecognition"
          tabs={tabs} />
      </DesktopWrapper>
    </>
  )
}

Account.contextTypes = {
  appPath: PropTypes.string.isRequired
}

export default injectIntl(Account)
